"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class GetChildAccountCreationStatus {
    static getAttributeTypeMap() {
        return GetChildAccountCreationStatus.attributeTypeMap;
    }
}
GetChildAccountCreationStatus.discriminator = undefined;
GetChildAccountCreationStatus.attributeTypeMap = [
    {
        "name": "childAccountCreated",
        "baseName": "childAccountCreated",
        "type": "boolean"
    }
];
exports.GetChildAccountCreationStatus = GetChildAccountCreationStatus;
//# sourceMappingURL=getChildAccountCreationStatus.js.map